import { ICartData, ICartGroup, ICartItems } from './interface';
import api from 'base/utils/api';
import { cartData } from 'mod/cart/mock-list';
import delay from 'base/utils/delay';


// export const fetchCartData= async (): Promise<ICartData> => {
//     await delay(2000);
//     return cartData;
// };

export const fetchCartData = (): Promise<ICartData> => {
    return api.post('/web/cart/v4/list').then(res => {
        const {groupInfoList, ...restData} = res;
        const groups = [] as ICartGroup[];
        const items = {} as ICartItems;

        res.groupInfoList.forEach(group => {
            const { cartItemList, ...restGroup } = group;

            const itemIds = [] as string[];
            cartItemList.forEach(item => {
                itemIds.push(item.id);
                items[item.id] = {
                    ...item,
                    isChangingQty: false,
                    isDeleting: false,
                    realNum: item.num,
                    groupCanSelect: restGroup.canSelect,
                };
            });

            groups.push({
                ...restGroup,
                itemIds,
            })
        });

        return {
            ...restData,
            groups,
            items
        }
    });
};